var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    opacity: 0.044,
    cx: 16,
    cy: 16,
    r: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.25 17.752h-1.502a6.757 6.757 0 0 1 6.757-6.756v1.501a5.251 5.251 0 0 0-5.256 5.255zm5.255-2.252V14a3.755 3.755 0 0 0-3.754 3.753h1.501a2.25 2.25 0 0 1 2.253-2.252zm-8.26-5.255c0-.833-.667-1.501-1.5-1.501-.834 0-1.502.668-1.502 1.501 0 .834.668 1.502 1.501 1.502.834 0 1.502-.668 1.502-1.502zm3.342.376h-1.502a2.239 2.239 0 0 1-2.215 1.876H9.618c-.623 0-1.126.503-1.126 1.127V15.5h4.505v-1.696a3.74 3.74 0 0 0 2.59-3.183zm5.669 9.383c.833 0 1.502-.668 1.502-1.501 0-.833-.669-1.501-1.502-1.501-.834 0-1.502.668-1.502 1.501 0 .833.668 1.501 1.502 1.501zm1.126.751H20.13a2.239 2.239 0 0 1-2.215-1.877h-1.502a3.74 3.74 0 0 0 2.59 3.183v1.697h4.505V21.88c0-.623-.503-1.126-1.126-1.126z",
    fill: "#121212",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3);
export default __webpack_public_path__ + "static/media/group-3.9b5d0e3a2b303b423eb16651d922df3d.svg";
export { ForwardRef as ReactComponent };